import { RootStateOrAny, useSelector } from 'react-redux';
import Link from 'next/link';
import { isEmpty } from '@utils/lodash';

import style from './style.module.less';

import ImageC from '@/components/Image';
const firstArray = 0;

const Footer = () => {
	const footer = useSelector((state: RootStateOrAny) => state.footer);
	const { description, get_close: getClose, feature, collaborate } = footer?.data?.record || {};
	const section1 = description ? description[firstArray] : {};
	const section2 = getClose ? getClose[firstArray] : {};
	const section3 = feature ? feature[firstArray] : {};
	const section4 = collaborate ? collaborate[firstArray] : {};

	const patternValidUrl = new RegExp(/^(http(s?)):\/\//i);
	const d = new Date();
	const year = d.getFullYear();

	if (isEmpty(footer)) {
		return null;
	}

	return (
		<div className={style['footer-section']}>
			<div className={style.top}>
				<div className={`container ${style.wrapper}`}>
					<div className={style.section1}>
						<div>
							<ImageC src="/images/klikdokter.svg" alt="KlikDokter" width={168} height={37} />
							<div
								className={style.title}
								dangerouslySetInnerHTML={{
									__html: section1?.detail && section1?.detail[0]?.sub_title,
								}}
							/>
							<div
								className={style.desc}
								dangerouslySetInnerHTML={{
									__html: section1?.detail && section1?.detail[0]?.description,
								}}
							/>
						</div>
						<div>
							<div
								className={style['title-footer']}
								dangerouslySetInnerHTML={{
									__html: section1?.detail && section1?.detail[0]?.title_footer,
								}}
							/>
							<ul>
								{!isEmpty(section1?.detail[0]) &&
									section1.detail[0].social_media.map((s: any, i: number) => {
										return (
											<li key={i}>
												<a href={s.deeplink} rel="nofollow">
													<ImageC src={s.icon} alt={s.name} width={32} height={32} />
												</a>
											</li>
										);
									})}
							</ul>
						</div>
					</div>
					<div className={style.section2}>
						<div className={style.title}>{section2?.name}</div>
						<ul>
							{!isEmpty(section2?.detail) &&
								section2.detail.map((menu: any, i: number) => {
									return (
										<li key={i}>
											{patternValidUrl.test(menu.deeplink) ? (
												<a href={menu.deeplink} rel="nofollow">
													{menu.name}
												</a>
											) : (
												<a href={menu.deeplink}>{menu.name}</a>
											)}
										</li>
									);
								})}
						</ul>
					</div>
					<div className={style.section3}>
						<div className={style.title}>{section3?.name}</div>
						<ul>
							{!isEmpty(section3?.detail) &&
								section3.detail.map((menu: any, i: number) => {
									return (
										<li key={i}>
											<Link href={menu.deeplink} legacyBehavior>
												{patternValidUrl.test(menu.deeplink) ? (
													<a rel="nofollow">{menu.name}</a>
												) : (
													<a>{menu.name}</a>
												)}
											</Link>
										</li>
									);
								})}
						</ul>
					</div>
					<div className={style.section4}>
						<div className={style.title}>{section4?.name}</div>
						<ul>
							{!isEmpty(section4?.detail) &&
								section4.detail.map((menu: any, i: number) => {
									return (
										<li key={i}>
											<Link href={menu.deeplink} legacyBehavior>
												<a>
													<div>{menu.name}</div>
												</a>
											</Link>
											<div>{menu.description}</div>
										</li>
									);
								})}
						</ul>
					</div>
				</div>
			</div>
			<div className={style.bottom}>
				<div className={`container ${style.wrapper}`}>
					<div className={style.kalbe}>
						<div>Bagian dari:</div>
						<ImageC src="/images/kalbe.svg" alt="Kalbe" width={110} height={50} />
					</div>
					<div>
						<span>Copyright @ {year}</span> <strong>PT Medika Komunika Teknologi</strong>
					</div>
					<div className={style.kemenkes}>
						<div>Mitra Resmi dari:</div>
						<ImageC
							src="/images/kemenkes.svg"
							alt="Kementerian Kesehatan Republik Indonesia"
							width={121}
							height={50}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
